import { useTranslation } from 'react-i18next';
import { Chip } from '@/components/ui/Chip';
import { Button } from '@/components/ui/Button';
import { cn } from '@/components/ui/cn';
import type { BudgetBucket } from '../types';
import type { BudgetBucketDef } from '../schema';

export interface BudgetSliderProps {
  value: BudgetBucket | null;
  onChange: (bucket: BudgetBucket | null) => void;
  buckets: readonly BudgetBucketDef[];
  className?: string;
}

/**
 * Discrete bucket selector for the budget question (Q3).
 * Vertical on mobile, horizontal on >=sm.
 */
export function BudgetSlider({ value, onChange, buckets, className }: BudgetSliderProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <div
        role="radiogroup"
        aria-label={t('quiz.q.budget.label')}
        className="flex flex-col gap-2 sm:flex-row sm:flex-wrap"
      >
        {buckets.map((bucket) => {
          const selected = value === bucket.id;
          return (
            <Chip
              key={bucket.id}
              pressed={selected}
              role="radio"
              onClick={() => onChange(bucket.id)}
              className="w-full justify-center sm:w-auto"
            >
              {t(bucket.label_key)}
            </Chip>
          );
        })}
      </div>
      <div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onChange(null)}
          aria-pressed={value === null}
        >
          {t('quiz.budget.skip')}
        </Button>
      </div>
    </div>
  );
}
